<nav class="navbar">
  <div class="navbar-brand">
    <a routerLink="/dashboard">
      <img class="nav-logo" src="assets/images/hageda-stumpf-klein-logo.svg" alt="Hageda Stumpf klein logo">
      @if (isQa()) {
        <pre class="nav-environment">&nbsp;QA</pre>
      }
      @if (isDev()) {
        <pre class="nav-environment">&nbsp;DEV</pre>
      }
      @if (isLocal()) {
        <pre class="nav-environment">&nbsp;LOCAL</pre>
      }
      @if (isDebugMode()) {
        <pre class="nav-environment--debug">&nbsp;debug</pre>
      }
    </a>
  </div>

  <div class="navbar-menu desktop-menu">
    <div class="nav-segment">
      <div class="nav-item"
           (mouseenter)="openDataMenu()"
           (mouseleave)="closeDataMenu()">
        <button class="nav-trigger text-uppercase btn-undr"
                #dataTrigger
                [cdkMenuTriggerFor]="dataMenu">
          Datencenter<span class="material-symbols-outlined">arrow_drop_down</span>
        </button>
        <ng-template #dataMenu>
          <div class="dropdown-menu" cdkMenu
               (mouseenter)="openDataMenu()"
               (mouseleave)="closeDataMenu()">
            @if (canAccessTile([
              'BULK_BILL_RECEIPT',
              'BULK_BILL',
              'CREDIT_NOTE',
              'VETERINARY_DRUG',
              'TRANSFUSION',
              'REIMPORT',
              'EXTENDED_BENEFIT'
            ])) {
              <a cdkMenuItem routerLink="/belege">Belegarchiv</a>
            }
            @if (canAccessTile(['MY_SALES'])) {
              <a cdkMenuItem routerLink="/umsatz">Umsatzkennzahlen</a>
            }
            @if (canAccessTile(['SLIMFIT_EVALUATIONS'])) {
              <a cdkMenuItem routerLink="/auswertungen">Auswertungen</a>
            }
          </div>
        </ng-template>
      </div>

      <div class="nav-item"
           (mouseenter)="openOrdersMenu()"
           (mouseleave)="closeOrdersMenu()">
        <button class="nav-trigger text-uppercase btn-undr"
                [cdkMenuTriggerFor]="ordersMenu"
                #ordersTrigger>
          Bestellung & Lieferung<span class="material-symbols-outlined">arrow_drop_down</span>
        </button>
        <ng-template #ordersMenu>
          <div class="dropdown-menu" cdkMenu
               (mouseenter)="openOrdersMenu()"
               (mouseleave)="closeOrdersMenu()">
            @if (canAccessTile(['ORDERS'])) {
              <a cdkMenuItem routerLink="/shop">Produktsuche</a>
            }
            @if (canAccessTile(['NACH'])) {
              <a cdkMenuItem routerLink="/nachlieferung">Nachlieferungliste</a>
            }
            <a cdkMenuItem routerLink="/vorbestellung/lagerware-grippe2026">Reservierung Lagerware Grippe</a>
            <a cdkMenuItem routerLink="/vorbestellung-archiv">Vorbestellung Archiv</a>
            @if (canAccessTile(['PREISLISTE'])) {
              <a cdkMenuItem routerLink="/shop/angebote">Hageda-Stumpf Angebotsdateien</a>
            }
            @if (canAccessTile(['TRACK_TRACE'])) {
              <a cdkMenuItem routerLink="/sendungsverfolgung">Sendungverfolgung</a>
            }
            @if (hasConditions() && canAccessTile(['ORDERS']) || userService.isAdmin()) {
              <a cdkMenuItem routerLink="/retouren">Retouren</a>
            }
          </div>
        </ng-template>
      </div>

      <div class="nav-item"
           (mouseenter)="openServicesMenu()"
           (mouseleave)="closeServicesMenu()">
        <button class="nav-trigger text-uppercase btn-undr"
                #servicesTrigger
                [cdkMenuTriggerFor]="servicesMenu">
          Services<span class="material-symbols-outlined">arrow_drop_down</span>
        </button>
        <ng-template #servicesMenu>
          <div class="dropdown-menu" cdkMenu
               (mouseenter)="openServicesMenu()"
               (mouseleave)="closeServicesMenu()">
            <a cdkMenuItem routerLink="/page/nachweise">Nachweise</a>
            <a cdkMenuItem routerLink="/page/aktuelle-informationen">Aktuelle Informationen</a>
            <a cdkMenuItem routerLink="/page/covid-19-informationen">COVID-19 Informationen</a>
            <a cdkMenuItem routerLink="/page/datev-info">DATEV Informationen</a>
            <a cdkMenuItem routerLink="/page/listen-unterlagen">Listen & Unterlagen</a>
          </div>
        </ng-template>
      </div>

      @if (userService.isMarketing()) {
        <div class="nav-item"
             (mouseenter)="openInternMenu()"
             (mouseleave)="closeInternMenu()">
          <button class="nav-trigger text-uppercase btn-undr"
                  #internTrigger
                  [cdkMenuTriggerFor]="internMenu">
            H-S Intern<span class="material-symbols-outlined">arrow_drop_down</span>
          </button>
          <ng-template #internMenu>
            <div class="dropdown-menu" cdkMenu
                 (mouseenter)="openInternMenu()"
                 (mouseleave)="closeInternMenu()">
              <a cdkMenuItem routerLink="/admin">Admin</a>
            </div>
          </ng-template>
        </div>
      }

    </div>

    <div class="nav-segment">
      <app-idf-select></app-idf-select>

          <button class="nav-trigger nav-icon" routerLink="/shop/cart" [matBadge]="cartCount" matBadgeColor="warn">
            <mat-icon fontSet="material-symbols-outlined" color="neutral" aria-hidden="false">shopping_cart</mat-icon>
          </button>

      @if (userService.isOwner()) {
        <div class="nav-item"
             (mouseenter)="openSettingsMenu()"
             (mouseleave)="closeSettingsMenu()">
          <button class="nav-trigger nav-icon pr-0"
                  #settingsTrigger
                  [cdkMenuTriggerFor]="settingsMenu">
            <mat-icon fontSet="material-symbols-outlined" color="neutral" aria-hidden="false">settings</mat-icon>
          </button>
          <ng-template #settingsMenu>
            <div class="dropdown-menu" cdkMenu
                 (mouseenter)="openSettingsMenu()"
                 (mouseleave)="closeSettingsMenu()">
              @if (!(this.userService.getUserLoadingObservable() | async) && canAccessTile(['GROUP_ACCOUNT_OWNER']) && !userService.isAdmin()) {
                <a cdkMenuItem routerLink="/subusers">Mitbenutzer</a>
              }
              @if (!(this.userService.getUserLoadingObservable() | async) && this.userService.canUseFeature('DATEV') && !userService.isAdmin()) {
                <a cdkMenuItem routerLink="/schnittstellen">Schnittstellen</a>
              }


              @if (!(this.userService.getUserLoadingObservable() | async) && canAccessTile(['GROUP_ACCOUNT_OWNER']) && !userService.isAdmin()) {
                <a cdkMenuItem routerLink="/benachrichtigungen">Benachrichtigungen</a>
              }

            </div>
          </ng-template>
        </div>
      }

      <div class="nav-item"
           (mouseenter)="openUserMenu()"
           (mouseleave)="closeUserMenu()">
        <button class="nav-trigger nav-icon"
                #userTrigger
                [cdkMenuTriggerFor]="userMenu">
          <mat-icon fontSet="material-symbols-outlined" color="neutral" aria-hidden="false">person</mat-icon>
          {{ userName }} <span class="material-symbols-outlined">arrow_drop_down</span>
        </button>
        <ng-template #userMenu>
          <div class="dropdown-menu" cdkMenu
               (mouseenter)="openUserMenu()"
               (mouseleave)="closeUserMenu()">
            @if (canAccessTile(['GROUP_ACCOUNT_OWNER', 'MASTER_DATA']) && !userService.isAdmin()) {
              <a cdkMenuItem routerLink="/stammdaten">Stammdaten</a>
            }
            @if (canAccessTile(['GROUP_ACCOUNT_OWNER']) && !userService.isAdmin()) {
              <a cdkMenuItem routerLink="/mein-profil">Mein Profil</a>
            }
            <a cdkMenuItem routerLink="/page/hgf">Hilfecenter</a>
            <a cdkMenuItem routerLink="/logout">Logout</a>
          </div>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="mobile-wrapper aic">
    <app-idf-select class="mob-select mr-m"></app-idf-select>

    <button class="hamburger" (click)="toggleMobileMenu()" [class.active]="mobileMenuOpen()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>

  <div class="navbar-menu mobile-menu" [class.open]="mobileMenuOpen()">
    <a (click)="closeMobileMenu()" routerLink="/dashboard" (click)="closeMobileMenu()" class="mobile-nav-link ">
      <span class="d-flex aie">
        <mat-icon fontSet="material-symbols-outlined" color="neutral" aria-hidden="false">home</mat-icon>  Dashboard
      </span>
    </a>
    <div class="mobile-nav-section" (click)="toggleDataSection()">
      <div class="mobile-nav-title"><span>Datencenter</span>
        <mat-icon fontSet="material-symbols-outlined">
          {{ dataSectionOpen() ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </div>
      <div class="mobile-nav-content" [class.open]="dataSectionOpen()">
        @if (canAccessTile([
          'BULK_BILL_RECEIPT',
          'BULK_BILL',
          'CREDIT_NOTE',
          'VETERINARY_DRUG',
          'TRANSFUSION',
          'REIMPORT',
          'EXTENDED_BENEFIT'
        ])) {
          <a (click)="closeMobileMenu()" routerLink="/belege" class="mobile-nav-link">Belegarchiv</a>
        }
        @if (canAccessTile(['MY_SALES'])) {
          <a (click)="closeMobileMenu()" routerLink="/umsatz" class="mobile-nav-link">Umsatzkennzahlen</a>
        }
        @if (canAccessTile(['SLIMFIT_EVALUATIONS'])) {
          <a (click)="closeMobileMenu()" routerLink="/auswertungen" class="mobile-nav-link">Auswertungen</a>
        }
      </div>
    </div>

    <div class="mobile-nav-section">
      <div class="mobile-nav-title" (click)="toggleOrdersSection()">
        <span>Bestellung & Lieferung</span>
        <mat-icon fontSet="material-symbols-outlined">
          {{ ordersSectionOpen() ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </div>
      <div class="mobile-nav-content" [class.open]="ordersSectionOpen()">
        @if (canAccessTile(['ORDERS'])) {
          <a (click)="closeMobileMenu()" routerLink="/shop" class="mobile-nav-link">Produktsuche</a>
        }
        @if (canAccessTile(['NACH'])) {
          <a (click)="closeMobileMenu()" routerLink="/nachlieferung" class="mobile-nav-link">Nachlieferungliste</a>
        }
        <a (click)="closeMobileMenu()" routerLink="/vorbestellung/lagerware-grippe2026"
           class="mobile-nav-link">Reservierung Lagerware Grippe</a>
        <a (click)="closeMobileMenu()" routerLink="/vorbestellung-archiv"
           class="mobile-nav-link">Vorbestellung Archiv</a>
        @if (canAccessTile(['PREISLISTE'])) {
          <a (click)="closeMobileMenu()" routerLink="/shop/angebote" class="mobile-nav-link">Hageda-Stumpf
            Angebotsdateien</a>
        }
        @if (canAccessTile(['TRACK_TRACE'])) {
          <a (click)="closeMobileMenu()" routerLink="/sendungsverfolgung" class="mobile-nav-link">Sendungverfolgung</a>
        }
        @if (hasConditions() && canAccessTile(['ORDERS']) || userService.isAdmin()) {
          <a (click)="closeMobileMenu()" routerLink="/retouren" class="mobile-nav-link">Retouren</a>
        }
      </div>
    </div>

    <div class="mobile-nav-section">
      <div class="mobile-nav-title" (click)="toggleServicesSection()">
        <span>Services</span>
        <mat-icon fontSet="material-symbols-outlined">
          {{ servicesSectionOpen() ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </div>
      <div class="mobile-nav-content" [class.open]="servicesSectionOpen()">
        <a (click)="closeMobileMenu()" routerLink="/page/nachweise" class="mobile-nav-link">Nachweise</a>
        <a (click)="closeMobileMenu()" routerLink="/page/aktuelle-informationen" class="mobile-nav-link">Aktuelle
          Informationen</a>
        <a (click)="closeMobileMenu()" routerLink="/page/covid-19-informationen" class="mobile-nav-link">COVID-19
          Informationen</a>
      </div>
    </div>
    @if (userService.isOwner()) {
      <div class="mobile-nav-section">
        <div class="mobile-nav-title" (click)="toggleSettingsSection()">
          <span>Einstellungen</span>
          <mat-icon fontSet="material-symbols-outlined">
            {{ settingsSectionOpen() ? 'expand_less' : 'expand_more' }}
          </mat-icon>
        </div>
        <div class="mobile-nav-content" [class.open]="settingsSectionOpen()">
          @if (!(this.userService.getUserLoadingObservable() | async) && canAccessTile(['GROUP_ACCOUNT_OWNER']) && !userService.isAdmin()) {
            <a (click)="closeMobileMenu()" routerLink="/subusers" class="mobile-nav-link">Mitbenutzer</a>
          }
          @if (!(this.userService.getUserLoadingObservable() | async) && this.userService.canUseFeature('DATEV') && !userService.isAdmin()) {
            <a (click)="closeMobileMenu()" routerLink="/schnittstellen" class="mobile-nav-link">Schnittstellen</a>
          }

          @if (!(this.userService.getUserLoadingObservable() | async) && canAccessTile(['GROUP_ACCOUNT_OWNER']) && !userService.isAdmin()) {
            <a (click)="closeMobileMenu()" routerLink="/benachrichtigungen"
               class="mobile-nav-link">Benachrichtigungen</a>
          }

        </div>
      </div>
    }

    <div class="mobile-nav-section">
      <div class="mobile-nav-title" (click)="toggleUserSection()">
        <span>Benutzer</span>
        <mat-icon fontSet="material-symbols-outlined">
          {{ userSectionOpen() ? 'expand_less' : 'expand_more' }}
        </mat-icon>
      </div>
      <div class="mobile-nav-content" [class.open]="userSectionOpen()">
        @if (canAccessTile(['GROUP_ACCOUNT_OWNER', 'MASTER_DATA']) && !userService.isAdmin()) {
          <a (click)="closeMobileMenu()" routerLink="/stammdaten" class="mobile-nav-link">Stammdaten</a>
        }

        @if (canAccessTile(['GROUP_ACCOUNT_OWNER']) && !userService.isAdmin()) {
          <a (click)="closeMobileMenu()" routerLink="/mein-profil" class="mobile-nav-link">Mein Profil</a>
        }
        <a (click)="closeMobileMenu()" routerLink="/page/hgf" class="mobile-nav-link">Hilfecenter</a>
      </div>
    </div>

    <a (click)="closeMobileMenu()" routerLink="/logout" (click)="closeMobileMenu()" class="mobile-nav-link">
      <span class="d-flex aie">
        <mat-icon fontSet="material-symbols-outlined" color="neutral" aria-hidden="false">logout</mat-icon>  Ausloggen
      </span> </a>

  </div>
</nav>
